import React, { useEffect, useState } from 'react';
import { buildingService, type Edificio } from '@/services/buildingService';
import { Button } from '@/components/ui/button';
import BuildingForm from '@/components/BuildingForm';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const BuildingsPage: React.FC = () => {
  const [buildings, setBuildings] = useState<Edificio[]>([]);
  const [, setLoading] = useState(true);
  const [, setError] = useState<string | null>(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentBuilding, setCurrentBuilding] = useState<Edificio | null>(null);
  const navigate = useNavigate();

  const fetchBuildings = async () => {
    try {
      setLoading(true);
      const data = await buildingService.getBuildings();
      setBuildings(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      setError(err.message);
      toast.error("Error al cargar los edificios.");
    } finally {
      setLoading(false);
    }
  };  useEffect(() => {
    fetchBuildings();
  }, []);

  const handleSaveBuilding = async (building: Edificio) => {
    try {
      if (building.id_edificio) {
        await buildingService.updateBuilding(building.id_edificio, building);
        toast.success("Edificio actualizado exitosamente.");
      } else {
        await buildingService.createBuilding(building);
        toast.success("Edificio creado exitosamente.");
      }
      fetchBuildings();
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      toast.error(`Error al guardar el edificio: ${errorMessage}`);
    }
  };

  const handleEdit = (building: Edificio) => {
    setCurrentBuilding(building);
    setIsFormOpen(true);
  };

  const handleDelete = async (id: string) => {
    if (window.confirm("¿Estás seguro de que quieres eliminar este edificio?")) {
      try {
        await buildingService.deleteBuilding(id);
        toast.success("Edificio eliminado exitosamente.");
        fetchBuildings();
      } catch (err: unknown) {
        const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
        toast.error(`Error al eliminar el edificio: ${errorMessage}`);
      }
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Mis Edificios</h1>
      <Button className="mb-4" onClick={() => { setCurrentBuilding(null); setIsFormOpen(true); }}>Agregar Nuevo Edificio</Button>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {buildings.map((building) => (
          <div key={building.id_edificio} className="border p-4 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold">{building.nombre_edificio}</h2>
            <p className="text-gray-600">{building.direccion}</p>
            <p className="text-gray-600">Unidades: {building.numero_unidades}</p>
            <div className="mt-4 flex space-x-2">
              <Button variant="outline" onClick={() => navigate(`/buildings/${building.id_edificio}`)}>Ver Detalles</Button>
              <Button variant="secondary" onClick={() => handleEdit(building)}>Editar</Button>
              <Button variant="destructive" onClick={() => handleDelete(building.id_edificio!)}>Eliminar</Button>
            </div>
          </div>
        ))}
      </div>
      <BuildingForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        onSave={handleSaveBuilding}
        initialData={currentBuilding}
      />
    </div>
  );
};

export default BuildingsPage;
